import React, { useState, useEffect } from 'react';

import {
  Box,
  Grid,
  Container,
  makeStyles
} from '@material-ui/core';

import { AiOutlineAreaChart } from "react-icons/ai";

import Page from 'src/components/Page';
import Alerts from '../../utils/alerts';
import api from '../../services/api'
import CompanyProfile from './Profile';
import CompanyLogo from './Logo';
import Toolbar from './Toolbar';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const defaultItem = {
  id: -1,
  numero: "000000",
  nome: "Sem Nome",
  descricao: "Sem Descrição",
  EMPRESA: "Empresa",
  dataCriacao: null,
  dataEncerramento: null,
  ativo: 1,
  logo: {}
}

const defaultDependencies = {
  statistics: []
}

const defaultState = {
  loaded: false,
  records: 10,
  pages: 0,
  page: 0,
  count: 0,
  rows: []
}

const defaultStartDateTime = new Date();
const defaultEndDateTime = new Date();

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const defaultResultColumns = [];

const defaultEmptyMessage = "Nenhuma Estatistica Foi Encontrada.";

const defaultfullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultResultModes = [defaultfullMode, defaultCompactMode];

const defaultVisions = [
  { id: 1, name: 'Estatisticas', refine: 1, label: 'Valores', history: 1 }
];

const defaultFilter = {
  pagina: 0,
  registros: 10,
  inicio: defaultStartDateTime,
  final: defaultEndDateTime,
  palavrachave: '',
  ordenacao: 'asc',
  ordem: '',
  visao: defaultVisions[0]
}

const Company = () => {

  const classes = useStyles();

  const [item, setItem] = useState(defaultItem);
  const [companyId, setCompanyId] = useState(localStorage.getItem('companyid'));

  const [openAlert, setOpenAlert] = useState(false);
  const [message, setMessage] = useState({});
  const [dependencies, setDependecies] = useState(defaultDependencies);

  const [filter, setFilter] = useState(defaultFilter);
  const [vision, setVision] = useState(defaultVisions[0]);
  const [resultModes, setResultModes] = useState(defaultResultModes);
  const [selectedMode, setSelectedMode] = useState(MODE_FULL);

  const [state, setState] = useState(defaultState);

  const openCreation = async (item) => {
    setItem(item);
  }

  const changeSort = (column, order) => {
    var value = {
      ...filter,
      ordem: column.sortable,
      ordenacao: order,
      pagina: 0,
    };
    setFilter(value);
  }

  const changeFilter = (startDateTime, endDateTime, vision, keyword, page, rows) => {
    var value = {
      ...filter,
      pagina: page,
      registros: rows,
      inicio: startDateTime,
      final: endDateTime,
      palavrachave: keyword,
      visao: vision
    };
    setVision(vision);
    setFilter(value);
  }

  const closeAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  const updateValues = (values) => {
    setItem(values);
    api.put('/companies/' + values._id, values).then((response) => {
      if (!response.data.error) {
        refreshItems();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
    })
  };

  const refreshItems = () => {
    setCompanyId(localStorage.getItem('companyid'));
    api.get('/companies/' + companyId, {}, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: 1,
          page: 1,
          count: response.data.length,
          rows: response.data
        });
      } else {
        setState(defaultState);
      }
    }).catch((error) => {
      console.error(error);
    })
  }

  useEffect(() => {
    if (!state.loaded) {
      refreshItems();
    }
    return
  }, []);

  return (
    <Page
      className={classes.root}
      title="Operação"
    >
      <Container maxWidth={false}>

        <Alerts message={message}
          open={openAlert}
          closeAlert={closeAlert} />


        <Toolbar
          icon={AiOutlineAreaChart}
          item={defaultItem}
          resultset={state}
          resultModes={resultModes}
          vision={vision}
          visions={defaultVisions}
          selectedMode={selectedMode}
          openCreation={openCreation}
          changeFilter={changeFilter}
        />


        <Box mt={3}>
          {state.rows.map((item) => (
            <Grid container spacing={0} direction='column' >

              <Grid
                item>
                <CompanyProfile item={item} updateValues={updateValues} />
              </Grid>

              <Grid
                item>
                <CompanyLogo item={item} statistics={dependencies.statistics} />
              </Grid>

            </Grid>

          ))}
        </Box>

      </Container>
    </Page>
  );
};

export default Company;
